
import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { ContactPhone, Create, FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import Button from 'components/CustomButtons/Button.js';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import ModalContact from './ModalContact';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 170 },
  { Header: 'Nombre Hoja', accessor: 'sheet_name'},
  { Header: 'Nombre Tabla', accessor: 'table_name'},
  { Header: 'Rango 1', accessor: 'range1'},
  { Header: 'Rango 2', accessor: 'range2'},
  { Header: 'Comentario', accessor: 'comment'},
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'REPORT_WHATSAPP_STORE',
  update: 'REPORT_WHATSAPP_UPDATE',
  show: 'REPORT_WHATSAPP_SHOW',
  delete: 'REPORT_WHATSAPP_DESTROY',
};
export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  const [model, setOpen] = useModal();
  const [openModalContact, setOpenModalContact] = useModal();
  const { id, showNotify, fDRDetails, Contact, reload, fileReports } = props;
  // console.log("CONTACTOS: ", Contact);

  return (
    <>
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          fileReports={fileReports}
          id={id}
        />
      ) : undefined}
      {openModalContact.open ? (
        <ModalContact
          model={openModalContact}
          setOpen={setOpenModalContact}
          showNotify={showNotify}
          contact={Contact?.filter(c => c.state === 'A')}
          reload={reload}/>
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard permission={ConstantPermissions[permission.store]}
            component={
              <CardIcon color="primary">
                <FileCopySharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado detallado de archivos para el reporte
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="archivos_reporte"
            defaultWidth={700}
            columns={columns}
            data={
              fDRDetails?.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <Button justIcon round simple color="info" onClick={() => setOpenModalContact(item)}>
                          <ContactPhone />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen(item)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="report/file-detail-report"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            reload();
                            setDataLoading(false);
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  table_name: item.table_name,
                  sheet_name: item.sheet_name,
                  range1: item.range1,
                  range2: item.range2,
                  comment: item.comment,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
